export enum ShopContactType {
  PHONE = 'PHONE',
  EMAIL = 'EMAIL'
}
